import React from "react";
import PropTypes from "prop-types";

const withSort = WrappedComponent => {
  class Sortable extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        field: props.sort.field,
        direction: props.sort.direction
      };
      this.handleSortChange = this.handleSortChange.bind(this);
    }

    handleSortChange(field) {
      const newState = {
        field,
        direction: "asc"
      };
      if (this.state.field === newState.field) {
        newState.direction = this.state.direction === "asc" ? "desc" : "asc";
      }
      this.props.onSortChange(newState);
      this.setState(newState);
    }

    render() {
      return (
        <WrappedComponent
          handleSortChange={this.handleSortChange}
          {...this.props}
        />
      );
    }
  }

  Sortable.propTypes = {
    sort: PropTypes.shape({
      field: PropTypes.string,
      direction: PropTypes.string
    }),
    onSortChange: PropTypes.func
  };

  Sortable.defaultProps = {
    sort: {
      direction: "asc"
    },
    onSortChange: () => {}
  };

  return Sortable;
};

export default withSort;
